import React , {useState,useEffect} from 'react';
import RadioBox from '../components/radio-box';
import ButtonSection from '../components/button-section';
import When from '../components/when';
import logo from "../img/logo-bleu.webp";

export default function Pension (props) {
    const [dataValid , setDataValid] =  useState(true);
	const [errors , setErrors] = useState([]);
	const [touchePension , setTouchePension] = useState(false);
    const [montantAnnuel , setMontantAnnuel] = useState(0);

    const {step , restart , simulationData} = props;

    const date=  new Date();
    const lastYear = date.getFullYear()-1;
    const  currentMonth = [
        'janvier',
        'février',
        'mars',
        'avril',
        'mai',
        'juin',
        'juillet',
        'aout',
        'septembre',
        'octobre',
        'novembre',
        'décembre'
    ][date.getMonth()];
    
    useEffect( ()=>{
        if ( !touchePension) {
            setDataValid(true);
            setErrors([]);
            setMontantAnnuel(0);

        }
    } ,[touchePension]);

    const nextStep = () => {
        if (dataValid){
            let data = {};
            
            data.touchePension = touchePension;
            if (touchePension){
                data.value = montantAnnuel/12;
            }

            props.updateData('pension' , data)
            props.nextStep();

        }
    }

    const changeMontant= ( e )=>{
        const newValue = parseInt(e.target.value);
        if (isNaN(newValue)){
            setErrors(['Veuillez saisir un montant valide.']);
            setDataValid(false);
        }else{
            setErrors([]);
            setDataValid(true);
        }
        setMontantAnnuel(newValue);

    }

    const changeTouchePension = ( value ) => {
        const newValue = JSON.parse(value);
        setTouchePension(newValue);
    }

    return <div className="sim-form min-height">
        <div className="question-pension">
            <div className="question">
                <RadioBox
                 model={{touchePension}}
                 handler = {changeTouchePension}
                 options = {{"Oui": true, "Non": false}}>Vous ou votre conjoint(e) actuel avez versé des pensions alimentaires depuis {currentMonth} {lastYear}</RadioBox>
            </div>
            <When condition = {touchePension}>
                <div className="montant-pension" style={{'marginTop': '2em'}}>
                    <div className="montant-input">
                        <label htmlFor="pension_alimentaire_versee">Montant Annuel</label>
                        <input 
                            type="number"
                            id="pension_alimentaire_versee"
                            name="pension_alimentaire_versee"
                            onChange={changeMontant}
                            placeholder="Ex:15000"
                            className="form-control"
                            />
                        <span className="euroSign">&euro;</span>
                    </div>
                </div>
            </When>
        </div>
        
        <ButtonSection
			restart={restart}
			action={nextStep}
			dataValid= {dataValid}
			errors={errors}
            data={simulationData}
            step={step}
		> 
		</ButtonSection>
            <div className="site-address pt-3 pt-sm-0">
      <div className="col">
        <img src={logo} alt="logo aide-sociale.fr"/>
      </div>
    </div>
    </div>
};